export default{
	login:{
		login:'Sign in',
		nibd:'NIBD MALL',
		code:'Verification Code',
    refreshCode:'refresh code',
		pwdPlaceholder:'password',
		codePlaceholder:'verification code',
		codeError:'verification code cannot be empty!',
    codeError2:'Please enter the 4-digit verification code correctly.',
    pwdError:'password cannot be empty!',
		phonePlaceholder:'mobile number',
		phoneError1:'Please enter your mobile number!',
		phoneError2:'Please enter the correct mobile number!',
		contact:'contact service',
		QR:'QR code of official account',
		QRTxt:'Follow the official account to reply to customer service',
		confirm:'confirm',
	},
	home:{
		home:'home',
		numSearch:'number search',
		notebook:'notebook',
    addNotebook:'Add notepad',
		feedback:'feedback',
		news:'news',
		signOut:'sign out',
		del:'delete',
		reply:'reply',
		edit:'edit',
		permissions:'Permissions',
		open:'open',
		oneself:'Visible only to oneself.',
    administrator:'administrator',
		NotepadCon:'Notepad content',
		recordInfo:"Let's record the information together ~",
		submit:'submit',
		cancel:"cancel",
		notebookPlaceholder:'Please enter your valuable comments on FREY.',
		picDesc:'Picture description',
		addPic:'Add pictures',
		welcome:'Welcome to NIBD MALL',
		scan:'Scan code on',
		palm:'Palm FREY MALL',
		miniBg:'Small program background wall',
	},
  routers:{
    login:'Login',
    home:'Home',
    partsCP:'Auto parts',
    parts:'Auto parts',
    partsDetails:'Accessories details',
    VINsearch:'VIN Search',
    cart:'Cart',
    shoppingCart:'Cart',
    count:'Purchase order confirmation',
    countSale:'Sales order confirmation',
    lackGoods:'Order submission completed',
    successGoods:'Order submitted successfully',
    lackSuccessGoods:'Order submission completed',
    manageAddress:'manage address',
    purchase:'Purchase order',
    purchaseOrder:'Purchase order',
    purchaseDetails:'Purchase order details',
    integralDetails:'Points order details',
    sale:'Sales order',
    saleOrder:'Sales order',
    otherSale:'Sales order（cass order）',
    otherDetail:'Order details（cass order）',
    saleDetails:'Sales order details',
    integralShop:'Integral mall',
    integralShopCP:'Integral mall',
    myPoints:'My points',
    stockControl:'Stock control',
    stock:'Stock control',
    customerManagement:'Customer',
    returnGoods:'Return',
    returnCP:'Return',
    newPurchase:'Create a new purchase return document',
    newSale:'Create a new sales return document',
    personalCenter:'Personal center',
    admin:'Personal center',
    editProfile:'Edit data',
    purchaseChart:'Purchasing statistical analysis',
    saleChart:'Statistical analysis of sales',
    sectorChart:'Classification analysis of annual purchase products',
    posterBuilder:'Poster generator',
    posterEdit:'Poster editor',
    eCard:'Electronic Business Card',
    addOrEditECard:'Generate electronic business cards',
  },
  table:{
    pic:'picture',
    PartsNum:'parts number',
    PartsInfo:'accessories information',
    engine:'engine',
    models:'models',
    carSeries:'car series',
    price:'price',
    stock:'stock',
    operate:'operate',
    oe:'OE',
    name:'name',
    brand:'brand',
    quality:'quality',
    area:'area',
    seller:'sales company',
    FOB:'FOB',
    remark:'remark',
    packaging:'packaging',
    colour:'colour',
    classify:'classify',
    packingMode:'packing mode',
    type:'type',
    years:'years',
    assembly:'picture',
    number1:'number',
    factory:'factory',
    number2:'number',
    record:'record',
    orderNo:'order No',
    date:'date',
    quantity:'quantity',
    unitPrice:'unit price',
    questions:'questions',
    pInfo:'information',
    quantityOrder:'quantity of order',
    noData:'No Data',
    desc:'describe',
    totalPrice:'total price',
    writeComments:'please write down your comments',
    add:'add',
    checkAll:'check all',
    partTypes:'types of accessories',
    totalQuantity:'total quantity',
    purchaseTotal:'total purchase order',
    salesTotal:'total sales orders',
    purchaseSettlement:'purchase settlement',
    salesSettlement:'sales settlement',
    customerName:'customer name',
    mobile:'mobile',
    customerType:'customer type',
    consignee:'consignee',
    detailedAddress:'detailed address',
    telephone:'telephone',
    areaCode:'area code',
    extension:'extension',
    telNumber:'telephone number',
    postcode:'postcode',
    priceY:'unit price (USD)',
    amount:'amount (USD)',
    fittingName:'fitting name',
    total:'total',
    orderStatus:'order status',
    orderDate:'order date',
    status:'status',
    createTime:'create time',
    returnQuantity:'return quantity',
    refund_amount:'refund amount',
    finishTime:'finish time',
    RMB:'$',
    exchangeRate:'exchange rate',
  },
  parts:{
    parts:'auto parts',
    searchBar:'expand the search bar',
    MSearch:'multi search',
    KeywordSearch:'keyword search',
    aikeywordPlaceholder:'keywords or NIBD',
    search:'search',
    scan:'in scan',
    VINsearch:'VIN search',
    VINplaceholder:'VIN number',
    VINscan:'VIN scan',
    MultiNumSearch:'Multi-number search',
    numberlistP:`please enter the OE number, if there are multiple OE numbers, press Enter to wrap. Example:
    11128645888
    2218350064
    51218402502`,
    empty:'empty',
    ImportExceldocuments:'import Excel document batch search',
    onlyExcel:'only supports Excel format',
    uploadFile:'select the file to upload',
    downloadTemplate:'template',
    classifiedSearch:'classified search',
    keywordsFilter:'enter keywords to filter',
    allParts:'all Auto Parts',
    sub:'subscriptions',
    hot:'hot',
    available:'available',
    stockArrival:'out of stock arrival',
    new:'new',
    ExportAll:'export all',
    ExportExcel:'export excel',
    Brand:'brand',
    carSeries:'car series',
    carModel:'car model',
    ownProducts:'own products',
    customerNum:'customer number',
    recommend:'REC',
    aBoxful:'a box of',
    dealerPrice:'dealer price',
    peerPrice:'peer price',
    repairPrice:'repair shop price',
    buy5:'buy 5 get 1 free',
    buy6:'add 6 pieces, the price is only 5 pieces',
    myStock:'my stock',
    on_way_stock:'stock in transit',
    otherDealers:'other dealers',
    details:'details',
    buy:'buy',
    marketPric:'market price inquiry',
    brandScreening:'brand screening',
    unselect:'unselect',
    inTheArea:'in the area',
    otherDealer:'other dealer inventory',
    dealerName:'dealer name',
  },
  partsDetails:{
    partsDetails:'accessories details',
    newPage:'details new window',
    sub:'subscriptions',
    sellingPrice:'suggested selling price',
    ask:'ask a question',
    citizens:'engaged citizens',
    batchNum:'batch number',
    noQuestions:'no questions from users at present',
    videos:'videos',
    noVideos:'there are no related videos at present',
    addNum:'add comparison number',
    askQuestions:'ask a Question',
    qestionsType:'question type',
    selectQuestion:'Please select a question type',
    cQuestion:'consultation question',
    pdFeedback:'product feedback',
    pdBatch:'optional, please enter the product batch number',
    problemDesc:'problem description',
    problemDescPlaceholder:'please enter your questions or questions about this product',
    supplementaryDesc:'supplementary description',
    addpic:'add pictures',
    newProduct:'new products',
    PackageDetails:'Package Details',
    PackageNum:'Package number',
    ItemNum:'Item number',
    ItemName:'Item Name',
    adaptationOE:'Item adaptation OE',
  },
  VINsearch:{
    VINsearch:'VIN Search',
    VehicleInfo:'Vehicle information',
    Transmission:'Transmission',
    frame:'frame',
    AdditionalInstructions:'Additional instructions',
    ReplacementNumber:'Replacement number',
    Sprices:'4S store prices',
    dosage:'dosage',
    StandardName:'Standard name',
    VINP:'Please enter the correct VIN',
  },
  cart:{
    cart:'cart',
    selectCustomers:'select customers',
    subAaccount:'sub-account screening',
    oneClickCollection:'one-click collection',
    emptyCart:'empty the shopping cart',
    noCustomerInfo:'there is no customer information at present, so you can add customer information in customer management',
    subtotal1:'subtotal of dealers',
    subtotal2:'subtotal of sales',
    toCustomer:'go to customer management',
    searchCustomers:'search customers',
    selectAcustomer:'please select a customer',
    successMsg:'success',
    errorMsg:'error',
    delGoods:'Delete the selected goods?',
    tip:'tip',
    delGoods2:'Please select the goods to delete',
    includeNnonIntegral:'Please include non-integral goods during settlement!',
    selectAcommodity:'Please select a commodity',
    onlyFreyCurrency:'N coin is only available for purchase settlement!',
    selectCollect:'Please select the products you want to collect!',
    selectAddress:'Select the delivery address',
    integralPrice:'integral price',
    freyCoin:'N coin',
    logisticsInfoP:'Please enter logistics delivery information',
    selectLogisticsP:'Please select logistics information',
    monthlyPayment:'transaction method: monthly payment',
    totalSalesOrders:'total sales orders',
    yuan:'USD',
    returnCart:'return to shopping cart',
    freyIntegralTotal:'Total points of N coin',
    submitOrder:'submit order',
    submittedSuccessfully:'order submitted successfully',
    orderDetails:'order details',
    continueToBuy:'Continue to buy',
    orderTipsCon1:'Dear customers, your order has been submitted successfully. ',
    orderTipsCon2:'Please enter the order list or the following order details to confirm the order,',
    orderTipsCon3:'and we will arrange the delivery of goods as soon as possible. Thank you for your support!',
    submissionCompleted:'order submission completed',
    completedTip:'Dear customer, your submitted spare parts order is out of stock for the time being! You can check the status of the order in the platform order, please pay attention in time, thank you for your support!',
    lackSuccessGoodsTipsCon1:'Dear customers, the following accessories order you submitted is successful.',
    completedTip2:'Dear customers, the following spare parts orders you submitted are out of stock for the time being! You can check the status of the order in the platform order, please pay attention in time, thank you for your support!',
    yourRequirements:'please enter your requirements',
  },
  manageAddress:{
    addressManage:'manage address',
    defAaddress:'default address',
    setDefault:'Set Default',
    modify:'modify',
    addAddress:'add address',
    modificationAddressrt:'modification address',
    selectLocation:'please select the location',
    setAsDefaultAddr:'set as default address',
    deliveryAddress:'delivery address',
    customerInfoModifi:'customer information modification',
    fillConsignee:'please fill in the consignee',
    fillAddress:'please fill in the detailed address',
    errorMobile:'mobile phone format error',
    telephoneCorrectly:'please fill in the fixed telephone number correctly',
    selectAddress2:'please select an address',
    addGoods:'please add goods',
    pAddAddress:'please add an address',
    delUser:'Do you want to delete this user?',
  },
  purchase:{
    purchase:'purchase',
    filterSearch:'filter search',
    orderQuery:'Order Query',
    reset:'reset',
    submissionTime:'submission time',
    orderNumP:'order number',
    orderStatusP:'select the order status',
    submissionTimeP:'select a submission time',
    orderTime:'order time',
    eDeliveryDate:'estimated delivery date',
    orderQuantity:'order quantity',
    actualQuantity:'actual quantity issued',
    orderTotal:'order total',
    actualTotal:'actual total',
    logisticsInfo:'logistics information',
    confirmOrder:'confirm order',
    confirmReceipt:'confirm receipt',
    submitReconciliation:'submit reconciliation',
    cancelTheOrder:'cancel the order',
    buyAgain:'buy again',
    integralOrder:'integral order',
    addcart:'add to cart',
    draft:'draft',
    confirmed:'confirmed',
    audited:'audited',
    alreadyPaid:'already paid',
    pickedUpGoods:'picked up goods',
    packed:'packed',
    loadedCar:'loaded car',
    receivedGoods:'received goods',
    reconciled:'reconciled',
    finished:'finished',
    returnedGoods:'returned goods',
    stockouts:'stockouts',
    delete:'delete',
    isCancelOrder:'Are you sure you want to cancel the order?',
    exportOrder:'export order',
    receivingInfo:'receiving information',
    address:'address',
    distributionInfo:'distribution information',
    outboundOrder:'outbound order number',
    packagesNum:'number of packages',
    orderInfo:'order information',
    customerReconciliation:'customer reconciliation',
    OneClickReconciliation:'One-click reconciliation',
    serialNum:'serial number',
    actualQuantity:'Actual delivery quantity',
    checkAccounts:'check accounts',
    confirmReconciliation:'confirm reconciliation',
    settlementMethod:'settlement method',
    monthlyAccount:'monthly account',
    expectedToEarnPoints:'expected to earn points',
    cent:'cent',
    rebateAmount:'rebate amount',
    commodityDelivery:'commodity delivery',
    financialReconciliation:'financial reconciliation',
    receiving:'One-click Receipt of goods',
  },
  stock:{
    shareInventoryDealers:'Click the button below to share the spare parts inventory with the dealers',
    sharedInventory:'shared inventory',
    downloadInventory:'Click Download Inventory Import Template to fill in, and then upload and update the inventory',
    clickUpload:'click upload',
    importSucceeded:'import succeeded',
    successfullyImported:'The inventory was successfully imported, and the imported inventory can be downloaded',
    downloadIInventory:'download import inventory',
    close:'close',
    importFailed:'import failed',
    failedCheck:'Inventory import failed. Please check whether the import format is correct',
    stock:'stock',
  },
  returnGoods:{
    returnGoods:'returnGoods',
    applicationTime:'application time',
    selectAtime:'please select a time',
    applicationStatus:'application status',
    selectApplicationStatus:'select the application status',
    newReturnOrder:'new return order',
    draftreturnOrder:'Draft return order',
    totalReturn:'total return',
    reasonReturn:'Reason for return',
    salesReturnDetails:'sales return order details',
    purchaseDetails:'purchase return order details',
    returnOrder:'return order',
    accessoriesSearch:'accessories search',
    accessoryNumber:'please enter the accessory number',
    draftRreturnOrder:'draft box of return order',
    generateReturnOrder:'generate a return order',
    addToReturnOrder:'add to return order',
    selectReturnReason:'please select a return reason',
    otherReasons:'other reasons for return',
    enterReturnReason:'please enter the return reason',
    confirmAdd:'confirm add',
    returnOrderGenerated:'Hello, your return order has been generated',
    returnProgressTip:'We will continue to pay attention to the return progress with you, thank you for your support!',
    viewOrders:'view orders',
    enterReturnedQuantity:'please enter the returned quantity',
    wantConfirm:'do you want to confirm?',
    wantDelete:'are you sure you want to delete this record?',
    noRecordsDel:'there are no records to delete',
    wantEmptRecord:'Are you sure you want to empty the record?',
    returnGoods:'returnGoods',
  },
  personalCenter:{
    personalCenter:'personal center',
    accountSetting:'account setting',
    posterGenerator:'poster generator',
    lastLogin:'last login',
    addAccountNumber:'add account number',
    only10Sub:'only 10 sub-accounts can be added',
    accountNumber:'account number',
    fullName:'(full) name',
    addTime:'add time',
    jurisdiction:'jurisdiction',
    editAccount:'edit account number',
    subAccount:'subaccount number',
    setPassword:'set password',
    isDisabled:'is it disabled',
    financial:'financial',
    priceInquiry:'price inquiry',
    entersubAccount:'enter the mobile phone number of sub-account',
    enterName:'please enter a name',
    setPasswordP:'please set the password',
    p3Digits:'password cannot be less than 3 digits',
    selectLeastOnePermission:'please select at least one permission',
    sell:'sell',
    avatar:'avatar',
    onlyJPG:'Only JPG and PNG formats are supported, and the file is less than 1M',
    uploadAvatar:'upload avatar',
    permissionSelection:'permission selection',
    accountPassword:'account password',
    modifyPassword:'modify password',
    save:'save',
    originalPassword:'original password',
    newPassword:'new password',
    confirmPassword:'Confirm password',
    originalPasswordP:'please enter the original password',
    newPasswordP:'please enter a new password',
    passwordAgainP:'enter the new password again',
    correctUsername:'please enter the correct user name',
    twicePasswords:'the passwords entered twice are inconsistent',
    onlyJPGPNG:'uploading avatar pictures can only be in JPG and PNG formats!',
    exceed1MB:'the size of the uploaded avatar image cannot exceed 1MB!',
    editNow:'edit now',
    returns:'go back',
    copy:'copy',
    download:'download',
    companyName:'name of the company',
    serviceHotline:'service hotline',
    product:'product',
    pleaseEnter:'please enter',
    contactAddress:'contact address',
    QRcode:'QR code',
    replace:'replace',
    generatePreview:'generate preview',
    replaceProduct:'replace product',
    keywordsNum:'accessories keywords/numbers',
    noData:'no data at present',
    pictureNotBeenLoaded :'the picture has not been loaded yet! Please wait ...',
    personalCenter:'个人中心',
  },
  integralMall:{
    Hello:'Hello',
    earnPoints:'Sign in to earn points',
    PointsRule:'Points rule',
    exchange:'exchange',
    RedeemNow:'Redeem now',
    lookAgain:'Take a look again',
    CurrentPoints:'Current points',
    checkIn:'Daily check-in',
    Points1:'1. From the 1st to 6th consecutive day of check-in: daily check-in points+1;',
    Points2:'2. Sign in continuously for one week: earn 5 points;',
    Points3:'3. Sign in for two consecutive weeks: earn 10 points;',
    Points4:'4. By analogy, add an additional 5 points per week to earn a maximum of 30 points;',
    Points5:'5. When continuous check-in is interrupted, return to the initial check-in status and accumulate the number of consecutive check-in days again;',
    ProductExchange:'Product exchange',
    Pd1:'1. Point products can only be redeemed using FREY currency and cannot be redeemed directly using points;',
    Pd2:'2. N coins are exchanged for points, and the ratio of FREY coins to points is 1:100;',
    Pd3:'3. Only point products cannot exist in the order, and accessory products must also be included in the order;',
    Pd4:'4. All point products purchased this time will be shipped together with the accessory products the next time they are shipped;',
    Pd5:'5. If overdue accounts are not cleared, points and gifts will not be exchanged;',
    current:'current',
    ProductDetails:'Product Details',
    PointPrice:'Point Price',
    AddToCart:'Add to cart',
    ProductDescription:'Product Description',
    nibd:'nibd',
    coin:'coin',
    my:'My',
    exchangeNibdCoin:'exchange N coin',
    insufficient:'Hello! Your N coin is insufficient. Please go to exchange N coins',
    nibdCoin:'N coin',
    myNnibdCoin:'my N coin',
    currentNibdCoin:'current N coin',
    TotalPoints:'Total points',
    pointsUused:'Total points used',
    availablePoints:'Total available points',
    AvailableNibdCoins:'Available N coin',
    ConvertedToNibdCoin:'Converted to N coin',
    ConvertibleNibdCoin:'Convertible N coin',
    UsedNibdCoin:'Used N coin',
    source:'source',
    describe:'describe',
    points:'points',
    specs:'specs',
  }
}



// WEBPACK FOOTER //
// ./src/locale/en.js